/*
 * @Author: Teemo Ding
 * @Date: 2022-03-02 16:36:14
 * @LastEditTime: 2022-06-10 09:03:52
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/CommunicationTemplates/index.tsx
 */
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { templateCategoryList } from '@/src/pages/Settings/Communication/CommunicationTemplateDetail/config';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { communicationTemplatesColumns } from '../config';
import css from '../css.module.less';
const templateCategoryValues = (templateCategoryList || [])
  .flatMap((item) => item.children)
  .map((item) => item.value);
const CommunicationTemplates = ({
  editFun,
  groupedTemplates,
  priorities,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelCommunication.index.communicationTemplates')}>
      {(groupedTemplates || []).map((item, index) => (
        <div key={index} style={{ marginTop: index === 0 ? 0 : 24 }}>
          <h3 className={css.tableTitle}>
            {
              (
                templateCategoryList.find(
                  (t) => t.key === item.categoryGroup,
                ) || {}
              ).label
            }
          </h3>
          <Table
            id='communicationTemplates'
            rowKey='category'
            className={css.communicationTemplatesTable}
            columns={communicationTemplatesColumns(
              item.categoryGroup,
              priorities,
              editFun,
              disableEdit,
              { getI18n },
            )}
            dataSource={item.categories.filter((c) =>
              templateCategoryValues.includes(c.category),
            )}
            pagination={false}
          />
        </div>
      ))}
    </SectionWrapper>
  );
};

export default CommunicationTemplates;
